import { MutableRefObject } from 'react';
import { FormState } from '@app/lib/form/contracts/FormState';
import {
    purchaseLifeInsurance,
    PurchaseLifeInsuranceResult,
} from '@app/service/eshop/life/actions/purchaseLifeInsurance';
import { AuthState } from '@app/infrastructure/auth/model/AuthState';
import { useDeathBeneficiaryManagement } from '@app/app/self-service/(wizard)/change-beneficiary-death/[id]/hooks/useDeathBeneficiaryManagement';
import { LifeProducts } from '@app/domain/model/eshop/life/LifeProducts';

export function createEnhancedFormAction(
    authState: AuthState,
    defaultCountryCode: string,
    beneficiaryManagement: ReturnType<typeof useDeathBeneficiaryManagement>,
    lifeProducts: LifeProducts,
    isCalculationOnlyRef: MutableRefObject<boolean>,
) {
    return async (prevState: FormState<PurchaseLifeInsuranceResult>, formData: FormData) => {
        const selectedCustomCovers: Array<{ code: string; sum: number }> = [];

        for (const [key, value] of formData.entries()) {
            if (key.startsWith('cover_') && key.endsWith('_enabled') && value === 'true') {
                const coverCode = key.replace('cover_', '').replace('_enabled', '');
                const coverValue = formData.get(`cover_${coverCode}_value`);

                if (coverValue !== null) {
                    selectedCustomCovers.push({
                        code: coverCode,
                        sum: Number(coverValue),
                    });
                }
            }
        }

        formData.set('selectedCustomCovers', JSON.stringify(selectedCustomCovers));

        const beneficiariesPayload = beneficiaryManagement.getBeneficiariesPayload().map(beneficiary => ({
            name: `${beneficiary.firstName} ${beneficiary.lastName}`.trim(),
            personalCode: beneficiary.personalCode,
            phone: beneficiary.phone ? `+372${beneficiary.phone}` : '',
            email: beneficiary.email ?? '',
            share: beneficiary.share ?? 0,
        }));

        formData.set('beneficiaries', JSON.stringify(beneficiariesPayload));

        formData.set('isCalculationOnly', isCalculationOnlyRef.current ? 'true' : 'false');

        return purchaseLifeInsurance(prevState, formData, defaultCountryCode, lifeProducts, authState);
    };
}
